function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApparel = function SvgApparel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    style: {
      fill: "#061e21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 33.67-3.03 1.93-4.24-2.58v-6.6h7.26M15.99 14v27h23V14zm19.24 0c0 3.88-3.47 7.02-7.74 7.02s-7.74-3.14-7.74-7.02zm-3.57 0c0 2.09-1.87 3.78-4.17 3.78s-4.17-1.69-4.17-3.78h8.33Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }));
};
export default SvgApparel;